// Sequence hooks
import { useEffect, useState } from "react"
import * as con from "../Constants"
import { isNullOrUndefined, isNullOrUndefinedOrBlank } from "../utils/generalFunctions"

import { RefStoredValue } from "./StoreHooks"

export const RefTextSequencesStatus = () => {

    const status = RefStoredValue(con.INPUT_TEXT_SEQUENCE_STATUS)
    const message = RefStoredValue(con.INPUT_TEXT_SEQUENCE_MESSAGE)
    const messageContext = RefStoredValue(con.INPUT_TEXT_SEQUENCE_MESSAGE_CONTEXT)

    const [actualStatus, setActualStatus] = useState(status)

    useEffect(() => {
        if (isNullOrUndefinedOrBlank(status))
            setActualStatus(con.STATUS_IS_MISSING)
        else
            setActualStatus(status)


    }, [status])


    return [actualStatus, message, messageContext]

}

export const RefUploadedFileSequencesStatus = () => {

    const status = RefStoredValue(con.UPLOADED_FILE_SEQUENCE_STATUS)
    const message = RefStoredValue(con.UPLOADED_FILE_SEQUENCE_MESSAGE)
    const messageContext = RefStoredValue(con.UPLOADED_FILE_SEQUENCE_MESSAGE_CONTEXT)

    const [actualStatus, setActualStatus] = useState(status)

    useEffect(() => {
        if (isNullOrUndefinedOrBlank(status))
            setActualStatus(con.STATUS_IS_MISSING)
        else
            setActualStatus(status)

    }, [status])


    return [actualStatus, message, messageContext]

}


export const RefIsFinalSequenceReadyForAnnotation = () => {
    const textStatus = RefStoredValue(con.INPUT_TEXT_SEQUENCE_STATUS)
    const uploadedStatus = RefStoredValue(con.UPLOADED_FILE_SEQUENCE_STATUS)
    const database = RefStoredValue(con.SELECTED_DATABASE)



    return (!isNullOrUndefined(database) &&
        (textStatus === con.STATUS_OK || uploadedStatus === con.STATUS_OK))

}


